<script setup lang="ts">
import { Moon, Sun, CircleHalf, ChevronRight } from "@/components/icons";
import {
  SelectContent,
  SelectItem,
  SelectItemText,
  SelectPortal,
  SelectRoot,
  SelectTrigger,
  SelectValue,
  SelectViewport,
} from "reka-ui";
import { useThemeStore } from "@/stores/themeStore";
import { computed } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
const themeStore = useThemeStore();

const selectedTheme = computed({
  get: () => themeStore.storedTheme,
  set: (value) => themeStore.setTheme(value),
});

const modes = [
  { value: "light", label: t("color_theme.light") },
  { value: "dark", label: t("color_theme.dark") },
  { value: "auto", label: t("color_theme.system") },
];
</script>

<template>
  <SelectRoot v-model="selectedTheme">
    <SelectTrigger class="flex items-center w-full justify-between pr-4">
      <div class="help-item">
        <Sun v-if="selectedTheme === 'light'" />
        <Moon v-else-if="selectedTheme === 'dark'" />
        <CircleHalf v-else />
        <SelectValue />
      </div>
      <ChevronRight class="text-icon-secondary" :size="20" />
    </SelectTrigger>
    <SelectPortal>
      <SelectContent
        class="z-50 bg-background-primary border border-border-primary shadow-card rounded-xl"
      >
        <SelectViewport>
          <SelectItem
            v-for="mode in modes"
            :key="mode.value"
            :value="mode.value"
            class="flex p-2 gap-2 m-1 rounded-lg text-text-primary/64 data-[state=checked]:bg-background-secondary secondary data-[state=checked]:text-text-primary hover:bg-background-secondary transition-colors"
          >
            <Moon v-if="mode.value === 'dark'" />
            <Sun v-else-if="mode.value === 'light'" />
            <CircleHalf v-else />
            <SelectItemText>{{ mode.label }}</SelectItemText>
          </SelectItem>
        </SelectViewport>
      </SelectContent>
    </SelectPortal>
  </SelectRoot>
</template>
